import { render, staticRenderFns } from "./NewDestinationPost.vue?vue&type=template&id=55902be2&scoped=true"
import script from "./NewDestinationPost.vue?vue&type=script&lang=js"
export * from "./NewDestinationPost.vue?vue&type=script&lang=js"
import style0 from "./NewDestinationPost.vue?vue&type=style&index=0&id=55902be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55902be2",
  null
  
)

export default component.exports